import { render } from "./VerifyAggregation.vue?vue&type=template&id=b57b8764&scoped=true"
import script from "./VerifyAggregation.vue?vue&type=script&lang=js"
export * from "./VerifyAggregation.vue?vue&type=script&lang=js"

import "./VerifyAggregation.vue?vue&type=style&index=0&id=b57b8764&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b57b8764"]])

export default __exports__